import { useQuery } from 'react-apollo'
import { WebappListPackages } from '../../../graphql/lab-orders/queries'
import { LabOrderSort, NameFilter, NameSort, ProjectPackage, ProjectPackagesPage } from '@labsavvyapp/components'
import { ListPartnerProjectPackages } from '../../../graphql/packages/queries'

/**
 *  Query to get the list of packages (aka order sets) based on provider id 

 * @param (providerId)
 * @returns PartnerCompendiumPage
 */

interface ListPackagesVariables {
  partnerId?: string
  projectId?: string
  providerId?: string
  limit?: number
  page?: number
  filter?: NameFilter
  sort?: NameSort
}

export const useQueryListPartnerProjectPackagesApi = (variables: ListPackagesVariables) => {
  const { partnerId, projectId, providerId, filter, limit, sort, page } = variables
  const isVariablesNotReady = !partnerId || !projectId || !providerId
  const {
    data: packageListData,
    error: packageListError,
    loading: packageListLoading,
    refetch: refetchPackageListData,
    fetchMore: fetchMorePackageListData,
  } = useQuery(ListPartnerProjectPackages, {
    variables: {
      partnerId: partnerId,
      projectId: projectId,
      providerId: providerId,
      limit: limit || 1000, // Default limit to 1000 if not provided
      sort: sort,
      filter: filter,
      page: page,
    },
    skip: isVariablesNotReady,
  })

  return {
    data: packageListData?.listPartnerProjectPackages?.packages as ProjectPackage[],
    error: packageListError,
    loading: packageListLoading,
    refetch: refetchPackageListData,
    fetchMore: fetchMorePackageListData,
  }
}
